// extracted by mini-css-extract-plugin
export default {"label":"CountryRow__label-W6h4G","name":"CountryRow__name-U2vry"};